const faqs = [
  {
    question: "Does Louisiana have its own regional passport agency?",
    answer: "No — Louisiana does not have a regional passport agency. The closest regional agencies are the Houston Passport Agency (approximately 5.5 hours from New Orleans via I-10) and the New Orleans Passport Acceptance Facility. Using a registered courier like Fast Passport Center is typically faster and more convenient.",
  },
  {
    question: "How fast can I get a passport in Louisiana?",
    answer: "With Fast Passport Center's courier service, Louisiana travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Louisiana?",
    answer: "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility — typically a post office, parish clerk, or public library. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Can I use a passport card for a Caribbean cruise from New Orleans?",
    answer: "A passport card is valid for closed-loop cruises (departing and returning to the same U.S. port) visiting only Canada, Mexico, Bermuda, and the Caribbean. However, a full passport book is strongly recommended as it covers all scenarios including emergency evacuations or flight rebookings mid-trip.",
  },
  {
    question: "How do I order a Louisiana birth certificate for a passport application?",
    answer: "Louisiana birth records are ordered through the Louisiana Department of Health Vital Records Registry. Note that Louisiana uses parishes instead of counties, and older records may be stored at the parish level rather than the state registry. Allow extra time if you are searching for older historical records. Online ordering is available through VitalChek.",
  },
  {
    question: "Which airport should I fly from for international travel from Louisiana?",
    answer: "Louis Armstrong New Orleans International (MSY) is the primary international gateway with direct service to Mexico, Canada, and Caribbean destinations. Baton Rouge Metropolitan (BTR) and Shreveport Regional (SHV) offer connections to major hubs. Houston Hobby (HOU) and Houston Bush (IAH) are also accessible from western Louisiana.",
  },
];

export { faqs };

export default function LAFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Louisiana Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Louisiana.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-white rounded-lg border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}